import { ContractFounderInterface } from '../interfaces/contractFounder';

export class ContractFounder implements ContractFounderInterface {
    id_contract_founder?: number;
    name: string;

    constructor() {
        this.name = '';
    }
}